export default [
    {
        path: "/",
        redirect: '/openList'
    },
    {
        path: "/openList",
        name: "openList",
        component: resolve => require(["@/pages/openList/index"], resolve)
    },
    {
        path: "/index/:meetingCode",
        name: "index",
        component: resolve => require(["@/pages/index/index"], resolve)
    },
    {
        path: "/login",
        name: "login",
        component: resolve => require(["@/pages/login/login"], resolve),
        redirect: 'adminLogin',
    },
    {
        path: "/login/:meetingCode",
        name: "login",
        component: resolve => require(["@/pages/login/login"], resolve)
    },
    {
        path: "/adminLogin",
        name: "adminLogin",
        component: resolve => require(["@/pages/login/adminLogin"], resolve)
    }, 
    // {
    //     path: "/h5login",
    //     name: "h5login",
    //     component: resolve => require(["@/pages/login/h5login"], resolve)
    // },
    {
        path: "/findpass",
        name: "findpass",
        component: resolve => require(["@/pages/login/findpass"], resolve)
    }, {
        path: "/accountBinding",
        name: "accountBinding",
        component: resolve => require(["@/pages/login/accountBinding"], resolve)
    }, {
        path: "/complementUnerInfo",
        name: "complementUnerInfo",
        component: resolve => require(["@/pages/login/complementUnerInfo"], resolve)
    },
    {
        path: "/register/:meetingCode",
        name: "register",
        component: resolve => require(["@/pages/login/register"], resolve)
    }, {
        path: '/error',
        name: 'error',
        component: resolve => require(['@/pages/error/error'], resolve)
    }, {
        path: "/main",
        name: "main",
        component: resolve => require(["@/pages/main"], resolve),
        redirect: 'home',
        children: [{
            path: '/home',
            name: 'home',
            component: resolve => require(["@/pages/home/Home.vue"], resolve),//默认的第一个地址
        }, {
            path: '/userList',
            name: 'userList',
            component: resolve => require(["@/pages/user/user.vue"], resolve),//用户管理
            meta: [{ name: 'userList', label: '用户管理' }],
        }
            , {
            path: '/userDetail',
            name: 'userDetail',
            component: resolve => require(["@/pages/user/userDetail.vue"], resolve),//用户管理=>详情
            meta: [{ name: 'user', label: '用户管理' }, { name: 'userDetail', label: '详情' }],
        }, {
            path: '/userEdit',
            name: 'userEdit',
            component: resolve => require(["@/pages/user/userEdit.vue"], resolve),//用户管理=>详情
            meta: [{ name: 'user', label: '用户管理' }, { name: 'userEdit', label: '编辑' }],
        }, {
            path: '/batchAdd',
            name: 'batchAdd',
            component: resolve => require(["@/pages/user/batchAdd.vue"], resolve),//用户管理=>批量创建
            meta: [{ name: 'user', label: '用户管理' }, { name: 'userEdit', label: '批量创建' }],
        }, {
            path: '/role',
            name: 'role',
            component: resolve => require(["@/pages/user/role.vue"], resolve),//角色管理
            meta: [{ name: 'role', label: '角色管理' }]
        }, {
            path: '/personCenterInfo',
            name: 'personCenterInfo',
            component: resolve => require(["@/pages/personCenter/personCenterInfo.vue"], resolve),//个人中心-------------------------------------------------------------------
            meta: [{ name: 'User Profile', label: '用户信息' }]
        }, {
            path: '/personCenterManager',
            name: 'personCenterManager',
            component: resolve => require(["@/pages/personCenter/personCenterManager.vue"], resolve),//--------
            meta: [{ name: 'User Profile', label: '账号管理' }]
        }, {
            path: '/personCenterLogs',
            name: 'personCenterLogs',
            component: resolve => require(["@/pages/personCenter/personCenterLogs.vue"], resolve),//--------
            meta: [{ name: 'User Profile', label: '登录日志' }]
        }, {
            path: '/Papers',
            name: 'Papers',
            component: resolve => require(["@/pages/paper/paperManager.vue"], resolve),//论文管理---------------------------------------------------------------
            meta: [{ name: 'Papers', label: '论文列表' }]
        }, {
            path: '/paperReviewManager',
            name: 'paperReviewManager',
            component: resolve => require(["@/pages/paper/paperReviewManager.vue"], resolve),//评审论文列表---------------------------------------------------------------
            meta: [{ name: 'paperReviewManager', label: '评审论文列表' }]
        }, {
            path: '/Submit',
            name: 'Submit',
            component: resolve => require(["@/pages/paper/createPaper.vue"], resolve),
            meta: [{ name: 'Papers', label: '论文管理' }, { name: 'Submit', label: '提交论文' }]
        }, {
            path: '/editPaper',
            name: 'editPaper',
            component: resolve => require(["@/pages/paper/editPaper.vue"], resolve),
            meta: [{ name: 'Papers', label: '论文管理' }, { name: 'editPaper', label: '编辑论文' }]
        }, {
            path: '/detailPaper',
            name: 'detailPaper',
            component: resolve => require(["@/pages/paper/detailPaper.vue"], resolve),
            meta: [{ name: 'Papers', label: '论文管理' }, { name: 'detailPaper', label: '论文详情' }]
        }, {
            path: '/reviewPaper',
            name: 'reviewPaper',
            component: resolve => require(["@/pages/paper/reviewPaper.vue"], resolve),
            meta: [{ name: 'Papers', label: '论文管理' }, { name: 'reviewPaper', label: '评审论文' }]
        }, {
            path: '/paperMeManager',
            name: 'paperMeManager',
            component: resolve => require(["@/pages/paper/paperMeManager.vue"], resolve),
            meta: [{ name: 'Papers', label: '论文管理' }, { name: 'paperMeManager', label: '我的论文' }],
        }, {
            path: '/meetManager',
            name: 'meetManager',
            component: resolve => require(["@/pages/meeting/meetManager.vue"], resolve),//会议管理--------------------------------------
            meta: [{ name: 'meetManager', label: '会议列表' }],
        }, {
            path: '/dayLog',
            name: 'dayLog',
            component: resolve => require(["@/pages/meeting/dayLog.vue"], resolve),//会议管理--------------------------------------
            meta: [{ name: 'dayLog', label: '访问日志' }],
        }, {
            path: '/meetConfig',
            name: 'meetConfig',
            component: resolve => require(['@/pages/meeting/meetConfig.vue'], resolve),
            meta: [{ name: 'meetManager', label: '会议管理' }, { name: 'meetConfig', label: '配置会议展示页' }],//会议=》前端配置
        }, {
            path: '/addMeeting',
            name: 'addMeeting',
            component: resolve => require(['@/pages/meeting/addMeeting.vue'], resolve),
            meta: [{ name: 'meetManager', label: '会议管理' }, { name: 'addMeeting', label: '创建会议' }],//会议=》新建页。
        }, {
            path: '/editMeeting',
            name: 'editMeeting',
            component: resolve => require(['@/pages/meeting/editMeeting.vue'], resolve),
            meta: [{ name: 'meetManager', label: '会议管理' }, { name: 'editMeeting', label: '编辑会议' }],//会议=》编辑页。
        }, {
            path: '/meetingDetail',
            name: 'meetingDetail',
            component: resolve => require(['@/pages/meeting/meetingDetail.vue'], resolve),
            meta: [{ name: 'meetManager', label: '会议管理' }, { name: 'meetingDetail', label: '会议详情' }],//会议=》详情页。
        },
        ]
    },
    {
        path: "/:meetingCode",
        name: "index",
        component: resolve => require(["@/pages/index/index"], resolve)
    },
    {
        path: '*',
        redirect: '/openList'
    }
];
